import $http from '@/libs/axios'

export default class InstagramMediaApi {
  static async postsList(pageId: number | null, accountId: any) {
    let url = `instagram/media/${accountId}/list`
    if (pageId) url += `/${pageId}`
    return (await $http.get(url)).data
  }

  static async storiesList(pageId: null | number, accountId: any) {
    let url = `instagram/media/${accountId}/stories`
    if (pageId) url += `/${pageId}`
    return (await $http.get(url)).data
  }

  static async mediaInsight(mediaId: any, accountId: any) {
    return (await $http.get(`instagram/media/${accountId}/insight/${mediaId}`)).data
  }

  static async leaveComment(mediaId: any, accountId: any, data: any) {
    return (await $http.post(`instagram/media/${accountId}/comment/${mediaId}`, data)).data
  }

  static async hashtagsSearch(query: any, accountId: any) {
    return (await $http.get(`instagram/hashtag/${accountId}/search?query=${query}`)).data
  }
}
